import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useAuthTheme, getAuthStyles, injectAuthKeyframes } from './AuthTheme';

injectAuthKeyframes();

const PARTICLES = [
  { top: '10%', left: '8%', animationDelay: '0s' },
  { top: '20%', right: '10%', animationDelay: '1s' },
  { top: '60%', left: '5%', animationDelay: '2s' },
  { bottom: '20%', right: '8%', animationDelay: '0.5s' },
  { bottom: '10%', left: '20%', animationDelay: '1.5s' },
  { top: '45%', right: '5%', animationDelay: '2.5s' },
];

export default function FacultyLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();
  const { dark } = useAuthTheme();
  const s = getAuthStyles();

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    if (!email.trim()) { setError('Email is required'); setLoading(false); return; }
    if (!password.trim()) { setError('Password is required'); setLoading(false); return; }
    if (!email.toLowerCase().includes('@faculty.')) {
      setError('Please use your faculty email (e.g. xyz@faculty.edu)');
      setLoading(false); return;
    }
    try {
      const result = await login(email, password, 'faculty');
      if (result?.success) navigate('/dashboard');
      else setError(result?.error || 'Invalid credentials');
    } catch { setError('Network error. Please try again.'); }
    finally { setLoading(false); }
  };

  return (
    <div style={s.page}>
      <div style={s.orb1} /><div style={s.orb2} /><div style={s.orb3} />
      <div style={s.particles}>
        {PARTICLES.map((p, i) => <div key={i} style={{ ...s.particle, ...p }} />)}
      </div>

      <div style={s.wrap}>
        <div style={s.brand} onClick={() => navigate('/')}>
          <div style={s.logoRing}><span style={s.logoEmoji}>👨‍🏫</span><div style={s.logoGlow} /></div>
          <h1 style={s.brandName}>UniResolve</h1>
          <p style={s.brandSub}>Faculty Portal</p>
        </div>

        <div style={s.card}>
          <div style={s.cardTop}><div style={s.cardTopBadge}>👨‍🏫 Faculty Login</div></div>
          <div style={s.cardBody}>
            <h2 style={s.heading}>Welcome Back</h2>
            <p style={s.sub}>Sign in to your faculty account</p>

            <div style={s.hintBox}>
              <span>📧</span>
              <span style={s.hintText}>Use your faculty email: <strong>xyz@faculty.edu</strong></span>
            </div>

            <form onSubmit={handleSubmit}>
              {error && <div style={s.err}><span>⚠️ {error}</span><button type="button" onClick={() => setError('')} style={s.errX}>×</button></div>}
              <div style={s.field}>
                <label style={s.label}>Faculty Email</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="xyz@faculty.edu" style={s.input} required />
              </div>
              <div style={s.field}>
                <label style={s.label}>Password</label>
                <div style={s.pwWrap}>
                  <input type={showPw ? 'text' : 'password'} value={password}
                    onChange={e => setPassword(e.target.value)} placeholder="Enter your password" style={s.input} required />
                  <button type="button" onClick={() => setShowPw(!showPw)} style={s.pwBtn}>{showPw ? 'Hide' : 'Show'}</button>
                </div>
              </div>
              <div style={s.optRow}>
                <span style={s.forgot} onClick={() => navigate('/forgot-password')}>Forgot Password?</span>
              </div>
              <button type="submit" disabled={loading} style={{ ...s.btn, ...(loading ? s.btnOff : {}) }}>
                {loading ? <span style={s.btnIn}><span style={s.spin} /> Signing in...</span> : 'Sign In as Faculty'}
              </button>
            </form>

            <div style={s.regRow}>
              <span style={s.regText}>Don't have an account? </span>
              <span style={s.regLink} onClick={() => navigate('/register/faculty')}>Register here</span>
            </div>
          </div>
        </div>
        <p style={s.footer}>© 2026 UniResolve</p>
      </div>
    </div>
  );
}
